var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40873 8H16.3178C16.3987 8.00007 16.4777 8.0241 16.5449 8.06906C16.6121 8.11402 16.6645 8.17788 16.6954 8.25259C16.7264 8.32729 16.7345 8.40949 16.7187 8.4888C16.703 8.56811 16.6641 8.64097 16.6069 8.69818L13.4542 11.8509V15.3636C13.4541 15.4294 13.4383 15.4941 13.4079 15.5524C13.3775 15.6107 13.3335 15.6609 13.2796 15.6985L11.916 16.6531C11.8547 16.696 11.7828 16.7212 11.7082 16.7261C11.6335 16.731 11.559 16.7153 11.4926 16.6808C11.4263 16.6463 11.3706 16.5942 11.3318 16.5303C11.293 16.4663 11.2724 16.393 11.2724 16.3182V11.8509L8.11964 8.69818C8.0625 8.64097 8.0236 8.56811 8.00784 8.4888C7.99209 8.40949 8.00019 8.32729 8.03112 8.25259C8.06205 8.17788 8.11443 8.11402 8.18164 8.06906C8.24885 8.0241 8.32787 8.00007 8.40873 8V8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionType);
export default __webpack_public_path__ + "static/media/transaction-type.430bde625e64b2ed044b16950ab3cf56.svg";
export { ForwardRef as ReactComponent };